export enum TimePeriod {
  AllTime = 'alltime',
  Last12Months = '12months',
  Last6Months = '6months',
  Last30Days = '30days',
  YearToDate = 'yeartodate',
  Last14Days = '14days',
  Last7Days = '7days',
  Last90Days = '90days',
  Custom = 'custom',
}
